export default __webpack_public_path__ + "static/media/dog.ed8ca7dd.glb";